<h1 mat-dialog-title>
  {{ data.title }}
</h1>
<div mat-dialog-content>
  {{ data.content }}
</div>
<div mat-dialog-actions>
  <button
    *ngIf="data.showYesButton"
    id="Yes"
    mat-raised-button
    color="primary"
    (click)="onYesButtonClick()"
  >
    <ng-container *ngIf="data.yesButtonTemplate; else defaultYesButton">
      <ng-container *ngTemplateOutlet="data.yesButtonTemplate"></ng-container>
    </ng-container>
    <ng-template #defaultYesButton>
      {{ data.yesButtonLabel }}
    </ng-template>
  </button>
  <button
    *ngIf="data.showNoButton"
    id="No"
    mat-raised-button
    color="secondary"
    (click)="onNoButtonClick()"
  >
    {{ data.noButtonLabel }}
  </button>
</div>